import dayjs from "dayjs";
import type { QuickQuoteDetails } from "../../hooks/react-query/backOffice/useQuickQuoteSummary";

export const mockQuickQuoteSummaryData: QuickQuoteDetails = {
  quoteDate: dayjs("2025-12-03T16:58:34.998Z").toDate(),
  shipmentDate: dayjs("2025-09-25T18:00:00.000Z").toDate(),
  account: {
    id: 12345,
    accountNumber: "20518658",
    accountName: "ALLIED ROOFING",
  },
  shipper: {
    id: 1699586,
    city: "LOS ANGELES",
    state: "California",
    zip: "90003",
    country: "United States",
    shortCountry: "USA",
  },
  consignee: {
    id: 1699631,
    city: "LOS ANGELES",
    state: "California",
    zip: "90047",
    country: "United States",
    shortCountry: "USA",
  },
  transitTime: "3",
  commodityDetails: [
    {
      nmfcClass: "50",
      weight: "10",
      weightUnit: "lbs",
    },
    {
      nmfcClass: "70",
      weight: "200",
      weightUnit: "lbs",
    },
  ],
  additionalServices: [
    {
      id: 4,
      title: "Inside Pickup Required",
      charge: "45.23",
    },
    {
      id: 138,
      title: "Delivery Appointment Not Required",
      charge: "116.14",
    },
    {
      id: 146,
      title: "Grocery Warehouse Delivery",
      charge: "198.15",
    },
  ],
  freightCharges: "47.75",
  grossCharge: "177.65",
  discountAmount: "0.46",
  discountPercent: "0.26",
  netCharge: "177.19",
  minimum: "277.36",
  adjustedNet: "277.36",
  fuelSurcharge: "128.93",
  standard: {
    quoteId: "41",
    totalAmount: "765.81",
  },
  guaranteed: {
    quoteId: "42",
    guaranteedService: "156.42",
    totalAmount: "922.23",
  },
};
